import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { profileApi } from '~/lib/request';
import { signOut } from '../auth/lib';

function useDeleteUserAccount() {
  const result = useMutation({
    mutationFn: () => profileApi.delete('api/profile/delete'),

    onSuccess: () => {
      toast.success('Profile removed!');

      setTimeout(() => {
        signOut();
      }, 1000);
    },

    onError: (error) => {
      console.error(error);

      toast.error('Cannot remove your account');
    },
  });

  return result;
}

export default useDeleteUserAccount;
